import { Form } from "antd";
import { useState } from "react";
import LoadingButton from "../../LoadingButton";
import ImageUpload from "../../imageupload/ImageUpload";


interface BrandingLogoUploaderProps {
  onSubmit: (value: { logoUrl: string }, form: any) => void;
  loading: boolean;
  initialValue?: string;
}

const BrandingLogoUploader: React.FC<BrandingLogoUploaderProps> = ({
  onSubmit,
  loading,
  initialValue = "",
}) => {
  const [form] = Form.useForm();
  const [logoUrl, setLogoUrl] = useState<{ path: string; refId: string } | null>(
    initialValue ? JSON.parse(initialValue) : null
  );

  const handleUploadComplete = (result: any) => {

    const file = result?.files[0];

    if (file?.path && file?.refId) {
      setLogoUrl({ path: file.path, refId: file.refId });
      form.setFieldValue("logoUrl", JSON.stringify({ path: file.path, refId: file.refId }));
    } else {
      console.warn("Upload result missing path or refId", result);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={() => onSubmit({ logoUrl: JSON.stringify(logoUrl) }, form)}
      initialValues={{ logoUrl: initialValue }}
    >
      <Form.Item name="logoUrl">
        <ImageUpload
          apiEndpoint="api/image-upload"
          enableCropping={true}
          allowMultiple={false}
          onUploadComplete={handleUploadComplete}
          title="Logo Upload"
        />
      </Form.Item>
      <Form.Item>
        <LoadingButton title="Set Logo" loading={loading} />
      </Form.Item>
    </Form>
  );
};

export default BrandingLogoUploader;
